var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "29px",
    viewBox: "0 0 25 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "export_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_matches_over",
    transform: "translate(-1017.000000, -27.000000)",
    stroke: "#EFB43F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "export_on",
    transform: "translate(1017.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,8.03559524 L2.67857143,8.03559524 C1.69285714,8.03559524 0.892857143,8.83559524 0.892857143,9.82130952 L0.892857143,21.4284524 C0.892857143,22.4153571 1.69285714,23.2141667 2.67857143,23.2141667 L22.3214286,23.2141667 C23.3071429,23.2141667 24.1071429,22.4153571 24.1071429,21.4284524 L24.1071429,9.82130952 C24.1071429,8.83559524 23.3071429,8.03559524 22.3214286,8.03559524 L18.75,8.03559524",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,23.2142857 L12.5,27.6785714",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.892857143,19.6428571 L24.1071429,19.6428571",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89285714,27.6428571 L16.7234128,27.6428571",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    points: "16.0714286 4.46416667 12.5 0.892738095 8.92857143 4.46416667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0.892738095 L12.5,15.1784524",
    id: "Stroke-12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportHover);
export default __webpack_public_path__ + "static/media/export-hover.5f49d12e361f033865cffc1209520f13.svg";
export { ForwardRef as ReactComponent };